import { User } from 'oidc-client';
import { AuthContext } from './auth-context';

export class UserContext {
    user: User;
    auth: AuthContext;
}